import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "form-content" }
const _hoisted_2 = {
  key: 0,
  class: "title"
}

import { onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import debounce from "lodash-es/debounce";

import { baseInput, baseTextarea } from "@/common/components";

import { MethodItemPayloadType } from "@/common/types/method/method-item";

import { FieldType } from "@/common/types/field";


export default /*@__PURE__*/_defineComponent({
  __name: 'method-item',
  props: {
    data: {},
    fields: {},
    title: {},
    width: { default: "100%" },
    order: {}
  },
  emits: ["update-data"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "v7543e60f": (_ctx.width)
}))

const { t } = useI18n();

const emit = __emit;

const props = __props;

const DEFAULT_PAYLOAD = {
  code: "",
  name: "",
  metadata: null,
};

const methodPayload = ref<MethodItemPayloadType>({ ...DEFAULT_PAYLOAD });
const metadataPayload = ref<FieldType[]>([]);

function update() {
  emit("update-data", methodPayload.value);
}

async function fetchFields() {
  if (!props.fields) return;

  await new Promise((resolve) => {
    metadataPayload.value =
      props.fields?.reduce((acc: FieldType[], field) => {
        if (field.type === "RANGE") {
          acc.push({
            ...field,
            answer: "",
            measure: "",
            min: "",
            max: "",
          });
        } else {
          acc.push({
            ...field,
            answer: "",
          });
        }
        return acc;
      }, []) ?? [];

    resolve(true);
  });
}

function fetchMetadata() {
  if (!props.data?.metadata) return;

  const metadata: FieldType[] = props.data.metadata;

  metadata?.forEach((field) => {
    metadataPayload.value?.map((item) => {
      if (item.field_id === field.field_id) {
        item.answer = field.answer;

        if (field.type === "RANGE") {
          item.measure = field.measure;
          item.min = field.min;
          item.max = field.max;
        }
      }

      return item;
    });
  });
}

function updateField() {
  methodPayload.value.metadata = metadataPayload.value;

  update();
}

const debouncedUpdate = debounce(update, 500);
const debouncedUpdateField = debounce(updateField, 500);

watch(
  () => props.fields,
  async () => {
    await fetchFields();
    fetchMetadata();
  },
);

watch(
  () => props.data,
  () => {
    fetchMetadata();
  },
);

onMounted(async () => {
  await fetchFields();

  if (props.data) {
    methodPayload.value = { ...props.data };

    fetchMetadata();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (__props.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("form", null, [
      _createVNode(_unref(baseInput), {
        modelValue: methodPayload.value.code,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((methodPayload.value.code) = $event)),
        value: methodPayload.value.code,
        placeholder: _unref(t)('common.placeholders.code'),
        onInput: _cache[1] || (_cache[1] = ($event: any) => (_unref(debouncedUpdate)()))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.code")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "placeholder"]),
      _createVNode(_unref(baseInput), {
        modelValue: methodPayload.value.name,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((methodPayload.value.name) = $event)),
        value: methodPayload.value.name,
        placeholder: _unref(t)('common.placeholders.name'),
        onInput: _cache[3] || (_cache[3] = ($event: any) => (_unref(debouncedUpdate)()))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.name")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "placeholder"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(metadataPayload.value, (item, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          (item.type === 'TEXT')
            ? (_openBlock(), _createBlock(_unref(baseInput), {
                key: 0,
                modelValue: item.answer,
                "onUpdate:modelValue": ($event: any) => ((item.answer) = $event),
                value: item.answer,
                onInput: _cache[4] || (_cache[4] = ($event: any) => (_unref(debouncedUpdateField)()))
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "value"]))
            : _createCommentVNode("", true),
          (item.type === 'NUMBER')
            ? (_openBlock(), _createBlock(_unref(baseInput), {
                key: 1,
                modelValue: item.answer,
                "onUpdate:modelValue": ($event: any) => ((item.answer) = $event),
                value: item.answer,
                type: "number",
                onInput: _cache[5] || (_cache[5] = ($event: any) => (_unref(debouncedUpdateField)()))
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "value"]))
            : _createCommentVNode("", true),
          (item.type === 'RANGE')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createVNode(_unref(baseInput), {
                  modelValue: item.measure,
                  "onUpdate:modelValue": ($event: any) => ((item.measure) = $event),
                  value: item?.measure,
                  placeholder: "ex: kg",
                  onInput: _cache[6] || (_cache[6] = ($event: any) => (_unref(debouncedUpdateField)()))
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name) + " " + _toDisplayString(_unref(t)("question.labels.measure")), 1)
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "value"]),
                _createVNode(_unref(baseInput), {
                  modelValue: item.min,
                  "onUpdate:modelValue": ($event: any) => ((item.min) = $event),
                  value: item?.min,
                  type: "number",
                  placeholder: "ex: 0.01",
                  onInput: _cache[7] || (_cache[7] = ($event: any) => (_unref(debouncedUpdateField)()))
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name) + " " + _toDisplayString(_unref(t)("question.labels.minimum")), 1)
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "value"]),
                _createVNode(_unref(baseInput), {
                  modelValue: item.max,
                  "onUpdate:modelValue": ($event: any) => ((item.max) = $event),
                  value: item?.max,
                  type: "number",
                  placeholder: "ex: 0.2",
                  onInput: _cache[8] || (_cache[8] = ($event: any) => (_unref(debouncedUpdateField)()))
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name) + " " + _toDisplayString(_unref(t)("question.labels.maximum")), 1)
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "value"])
              ], 64))
            : _createCommentVNode("", true),
          (item.type === 'TEXTAREA')
            ? (_openBlock(), _createBlock(_unref(baseTextarea), {
                key: 3,
                modelValue: item.answer,
                "onUpdate:modelValue": ($event: any) => ((item.answer) = $event),
                value: item.answer,
                onInput: _cache[9] || (_cache[9] = ($event: any) => (_unref(debouncedUpdateField)()))
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "value"]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ])
  ]))
}
}

})